import { ArrowLeftIcon } from 'lucide-react'
import React from 'react'

import OpacityTransition from './reusable/OpacityTransition'

interface Props {
  onBack: () => void
}

export default function InviteEmployeesInstructions ({ onBack }: Props) {
  return (
    <div className='flex-1 overflow-auto'>
      <OpacityTransition key='instructions'>
        <div className='text-sm font-light'>
          <div
            className='flex content-center text-thatch-purple-primary text-sm cursor-pointer pb-4 w-48 items-center'
            onClick={onBack}
          >
            <ArrowLeftIcon className='self-center' size={16} />
            <span className='pl-2'>Back to employee invites</span>
          </div>
          <div>
            <div className='text-base font-bold mb-2'>
              Configurable options available:
            </div>
            <div className='mb-2'>
              <span className='font-semibold'>1. Enrollment Event:</span>{' '}
              The type of event an employee is being invited for. Options
              include:
            </div>
            <div className='mb-2'>
              <div className='ml-2'>
                <span className='font-normal'>a. ICHRA Invite:</span>{' '}
                Initial invite employees to enroll in an ICHRA
              </div>
              <div className='ml-2'>
                <span className='font-normal'>b. Open Enrollment:</span>{' '}
                (Only available if renewing for next year) Invite
                employees to enroll in benefits during Open Enrollment for
                the next plan year. Available late October.
              </div>
              <div className='ml-2 italic'>
                c. Other events to come...
              </div>
            </div>
            <div className='mb-2'>
              <span className='font-semibold'>2. Plan Year:</span> The
              plan year the employee is invited to enroll within. Defaults
              to the current plan year. If you choose to renew your
              contract for the next plan year, next year's plan year will
              be become available for Open Enrollment.
            </div>
            <div className='mb-2'>
              <span className='font-semibold'>3. Start Date:</span> The
              date the employee will be invited to onboard with Thatch.
            </div>
            <div className='mb-2'>
              <div className='ml-2'>
                <span className='font-normal italic'>
                  a. If the employee is invited for today's date,
                </span>{' '}
                an invite will be sent immediately.
              </div>
              <div className='ml-2'>
                <span className='font-normal italic'>
                  b. If the employee is invited for a future date,
                </span>{' '}
                an invite will be sent the morning of the specified date.
                Prior to the invite being sent you may edit the invite at
                any time.
              </div>
            </div>
            <div className='mb-2'>
              <span className='font-semibold'>
                4. Enrollment Window Length:
              </span>{' '}
              The number of days the employee has to enroll with Thatch
              for healthcare benefits.
            </div>
          </div>
        </div>
      </OpacityTransition>
    </div>
  )
}
